import { render, staticRenderFns } from "./DragReorderable.vue?vue&type=template&id=8a5f4cc0&"
import script from "./DragReorderable.vue?vue&type=script&lang=ts&"
export * from "./DragReorderable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports